import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { AnalyzeVideoModal } from "@/components/AnalyzeVideoModal";
import { PremiumUpgradeModal } from "@/components/PremiumUpgradeModal";
import { Footer } from "@/components/layout/Footer";
import { useAuth } from "@/context/AuthContext";

const TITLES = {
  "/dashboard": "Overview",
  "/library": "Video Library",
  "/analytics": "Analytics",
  "/compare": "Compare Videos",
  "/ai-insights": "AI Insights",
  "/competitors": "Competitors",
  "/ideas": "Idea Lab",
  "/team": "Team & Access",
  "/settings": "Settings & Plan",
};

export function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [search, setSearch] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const showAdBanner = user?.plan === "free";

  const title = TITLES[location.pathname] || "Overview";

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Desktop sidebar */}
      <div className="hidden lg:block shrink-0">
        <Sidebar />
      </div>

      {/* Mobile sidebar */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-64 border-border">
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar
          onMenu={() => setMobileOpen(true)}
          search={search}
          setSearch={setSearch}
          title={title}
        />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto max-w-6xl px-4 lg:px-8 py-6 lg:py-8">
            <Outlet context={{ search, setSearch }} />
          </div>
          {showAdBanner && (
            <div className="mx-auto max-w-6xl px-4 lg:px-8 pb-8">
              <div
                className="rounded-xl border border-border bg-secondary/40 px-5 py-3 flex items-center justify-between gap-4"
                data-testid="app-ad-banner"
              >
                <p className="text-xs text-muted-foreground">
                  <span className="overline mr-2 text-[0.6rem]">Ad</span>
                  You're on the Free plan. Upgrade to Pro or Plus to remove banners and unlock more daily analyses.
                </p>
              </div>
            </div>
          )}
          <Footer compact />
        </main>
      </div>

      <AnalyzeVideoModal onSuccess={(a) => navigate(`/analysis/${a.id}`)} />
      <PremiumUpgradeModal />
    </div>
  );
}
